<script setup>
// NOTICE: KAPTION-INTEGRATION
// Simplified test page for KaptionInlineTemplateEditor component
import { ref } from 'vue';
import KaptionInlineTemplateEditor from 'dashboard/components-next/Campaigns/KaptionInlineTemplateEditor.vue';

// Template with numbered variables (WhatsApp standard)
const templateText = ref(
  'Hi {{1}}, this is a reminder that your appointment is scheduled for {{2}} at {{3}}. Please arrive 15 minutes early. If you need to reschedule, contact us at {{4}}.'
);

// Example with named variables (also supported)
const namedTemplateText = ref(
  'Hello {{name}}, your order #{{order_id}} has been shipped! Expected delivery: {{delivery_date}}. Track at {{tracking_url}}.'
);

// Variable bindings for both templates
const variableBindings = ref({ body: {} });
const namedVariableBindings = ref({ body: {} });

// Sample contacts for autocomplete
const sampleContacts = ref([
  {
    id: 1,
    name: 'John Doe',
    email: 'john@example.com',
    phone_number: '+1234567890',
    custom_attributes: {
      company: 'Acme Inc',
      tier: 'Premium',
    },
  },
  {
    id: 2,
    name: 'Jane Smith',
    email: 'jane@example.com',
    phone_number: '+0987654321',
    custom_attributes: {
      company: 'Tech Corp',
      tier: 'Basic',
    },
  },
]);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template -->
  <div class="p-8">
    <h1 class="text-3xl font-bold mb-2">Inline Template Editor</h1>
    <p class="text-n-slate-11 mb-8">
      Click on the highlighted variables to edit them directly inline.
    </p>

    <!-- Example 1: Numbered Variables (WhatsApp standard) -->
    <div class="max-w-3xl mb-12">
      <h2 class="text-lg font-semibold text-n-slate-12 mb-3">
        Numbered Variables (WhatsApp Standard)
      </h2>
      <KaptionInlineTemplateEditor
        v-model="variableBindings"
        :template-text="templateText"
        :sample-contacts="sampleContacts"
      />
      <div class="mt-4 p-3 rounded-lg bg-n-alpha-black1">
        <pre class="text-xs text-n-slate-11 font-mono">{{
          JSON.stringify(variableBindings.body, null, 2)
        }}</pre>
      </div>
    </div>

    <!-- Example 2: Named Variables -->
    <div class="max-w-3xl">
      <h2 class="text-lg font-semibold text-n-slate-12 mb-3">
        Named Variables (Also Supported)
      </h2>
      <KaptionInlineTemplateEditor
        v-model="namedVariableBindings"
        :template-text="namedTemplateText"
        :sample-contacts="sampleContacts"
      />
      <div class="mt-4 p-3 rounded-lg bg-n-alpha-black1">
        <pre class="text-xs text-n-slate-11 font-mono">{{
          JSON.stringify(namedVariableBindings.body, null, 2)
        }}</pre>
      </div>
    </div>
  </div>
</template>
